import { render, staticRenderFns } from "./Wishlist.vue?vue&type=template&id=78ce29d4&"
import script from "./Wishlist.vue?vue&type=script&lang=js&"
export * from "./Wishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports